import { render, staticRenderFns } from "./Homephone.vue?vue&type=template&id=0f2fed89&scoped=true&"
import script from "./Homephone.vue?vue&type=script&lang=js&"
export * from "./Homephone.vue?vue&type=script&lang=js&"
import style0 from "./Homephone.vue?vue&type=style&index=0&id=0f2fed89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2fed89",
  null
  
)

export default component.exports